export default "__VITE_ASSET__1afecc54__"